import { SKILL_ICONS } from "./skillIcons";

const cardsData = [
  {
    icon: SKILL_ICONS.brandStrategy,
    title: "Brand Strategy & Identity",
    desc: "Defining brand vision, voice, and visual systems that stay consistent across every touchpoint.",
  },
  {
    icon: SKILL_ICONS.artDirection,
    title: "Art Direction",
    desc: "Leading the visual language of campaigns, from concept and mood to final execution across channels.",
  },
  {
    icon: SKILL_ICONS.campaignDevelopment,
    title: "Campaign Development",
    desc: "Shaping integrated campaign ideas, messaging, and creative routes that connect with audiences.",
  },
  {
    icon: SKILL_ICONS.teamLeadership,
    title: "Creative Team Leadership",
    desc: "Guiding designers and collaborators, aligning stakeholders, and keeping projects moving from idea to delivery.",
  },
];

export default cardsData;
